import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
  selector: '.input-group-field'
})
export class InputGroupDirective {
  constructor(private elementRef: ElementRef) { }

  @HostListener('focus')
  focusParent(): void {
    this.elementRef.nativeElement.parentElement.classList.add('active');
  }

  @HostListener('blur')
  blurParent(): void {
    this.elementRef.nativeElement.parentElement.classList.remove('active');
  }
}
